module.exports = __webpack_public_path__ + "static/media/github.07883e93.svg";